<template>
  <section class="page-user-faq py-5">
    <app-loading :isFull="true" v-if="isLoading"/>
    <vue-modaltor
      :visible="isModal"
      @hide="hideModal"
      :default-width="'50%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width="{1200:'60%',992:'80%',768:'90%'}"
    >
      <div class="col-12">
        <div class="group-form">
          <textarea
            type="text"
            v-validate="'required'"
            name="reply"
            :class="{active:reply != '' }"
            v-model="reply"
          ></textarea>
          <span class="bar"></span>
          <label class="statr">نظر شما ؟</label>
          <span v-if="errors.has('reply')" class="is-danger">فیلد نباید خالی باشد</span>
        </div>
      </div>
      <div class="col-4">
        <div class="form-action my-2">
          <button
            class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
            v-ripple
            @click="newCommentReply"
          >ثبت پاسخ</button>
        </div>
      </div>
    </vue-modaltor>
    <div class="container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <header>
              <h2 class="rtl text-right mb-2 font-20">{{$t('word.comments')}}</h2>
            </header>
            <comments
              @getReply="getReply(comment,index)"
              :item="comment"
              v-for="(comment,index) in comments"
              :key="comment.id"
              @replyComment="replyComment(comment,index)"
            />
          </div>
        </div>
      </div>
      <contact-form
        :action="true"
        :inputs="reviewsForm"
        :title="'فرم ارسال نظر'"
        class="my-2"
        @submitAction="newComment"
      />
    </div>
  </section>
</template>

<script>
import contactForm from 'cp/contact-form.vue'
import comments from 'cp/comments.vue'

export default {
  name: 'page-user-comment',
  components: {
    contactForm,
    comments
  },
  data() {
    return {
      isLoading: true,
      isModal: false,
      reply: '',
      reviewsForm: [
        {
          type: 'rate',
          name: 'rate',
          label: 'امتیاز شما به این دوره',
          model: 1,
          col: '12'
        },
        {
          type: 'textarea',
          name: 'content',
          label: 'نظر خود را مطرح کنید',
          msg: 'لطقا فرم را پر کنید',
          model: '',
          col: '12',
          rule: 'required'
        }
      ],
      itemReply: null
    }
  },
  computed: {
    courseId() {
      return this.$route.params.id
    },
    comments() {
      return this.$store.state.contentCourses.comments
    }
  },
  mounted() {
    this.commentGet()
  },
  methods: {
    hideModal() {
      this.hideModal = false
    },
    async getReply(item, index) {
      this.isLoading = true
      console.log(item, index)

      await this.$store.dispatch('contentCourses/getCommentsReply', { id: item.id, index })
      this.isLoading = false
    },
    replyComment(item, index) {
      this.itemReply = { item, index }
      this.isModal = true
    },
    async newCommentReply() {
      this.isLoading = true
      await this.$store.dispatch('contentCourses/commentReplyNew', { comment: this.itemReply.item.id, reply: this.reply, index: this.itemReply.index })
      this.isLoading = false
    },
    async commentGet() {
      this.isLoading = true
      await this.$store.dispatch('contentCourses/commentGet', { course_id: parseInt(this.courseId) })
      this.isLoading = false
    },
    async newComment() {
      this.isLoading = true
      let reviewsForm = this.formHandeler(this.reviewsForm)
      reviewsForm.course = parseInt(this.courseId)
      await this.$store.dispatch('contentCourses/postCommentNew', reviewsForm)
      this.isLoading = false
      this.commentGet()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/courses/_en_category/_en_subcategory/_id/_course_title_encourses/comment/index.vue